import { replaceMessages } from "../store/conversation/actions";
import { initSurvey } from "../store/survey/actions";
import { nextPage } from "../store/page/actions";

const CUSTOMER_EXPERIENCE = "CustomerExperience";
const END = "End";

export function getReconciliationPayload(response) {
  return response?.data?.data || response?.data || {};
}

export function applyReconciliationResult(dispatch, payload, webChatId) {
  const missingMessages = payload?.messages;
  if (missingMessages && Array.isArray(missingMessages) && missingMessages.length > 0) {
    dispatch(replaceMessages(missingMessages));
  }

  const survey = payload?.survey;
  const hasActiveSurvey = Boolean(survey?.pendingSurveyId && survey?.active && survey?.questionMain);

  if (hasActiveSurvey) {
    dispatch(
      initSurvey(
        survey.conversa_id,
        survey.questionMain,
        survey.pendingSurveyId,
        true
      )
    );
    dispatch(nextPage(CUSTOMER_EXPERIENCE));
  } else if (payload?.isClosed) {
    dispatch(nextPage(END));
  }

  if (payload?.isClosed && webChatId) {
    localStorage.removeItem(
      `${process.env.REACT_APP_KEY_ID_CONVERSATION}-${webChatId}`
    );
    localStorage.setItem(`conversationAttendant-${webChatId}`, "false");
  }
}
